import { render, staticRenderFns } from "./EducationExams.vue?vue&type=template&id=6b856ca2&scoped=true&"
import script from "./EducationExams.vue?vue&type=script&lang=js&"
export * from "./EducationExams.vue?vue&type=script&lang=js&"
import style0 from "./EducationExams.vue?vue&type=style&index=0&id=6b856ca2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b856ca2",
  null
  
)

export default component.exports